module.exports = __webpack_public_path__ + "img/methodical-image.28b1f4a1.png";